import { AxiosInstance } from "axios"
import { ServiceResponse } from "../../core/api/apiTypes"
import {
    ChangePasswordParams,
    ChangeAccountResponse,
    GetUserAccountsResponse,
    ConfirmEmailParams,
    UserAccountsResponse,
} from "./profileTypes"
import { AuthenticationResponse } from "../login/loginTypes"

export enum ProfileQuery {
    GET_USER_ACCOUNT = "get-user-account",
}

export async function changePassword(
    params: ChangePasswordParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const response = await axios.post(
        "/me/changePassword",
        {
            ...params,
        },
        {
            signal,
        },
    )
    return response.data
}

export async function getUserAccounts(
    { userId }: { userId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<UserAccountsResponse> {
    const response = await axios.get(`/users/${userId}/userAccounts`, {
        signal,
    })
    return response.data
}

export async function sendEmailConfirmation(
    {},
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const response = await axios.get("/me/confirmationEmail", {
        signal,
    })
    return response.data
}

export async function changeAccount(
    { uid }: { uid: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ChangeAccountResponse> {
    const response = await axios.post(
        "/authenticate/changeAccount",
        {
            switchAccountTo: {
                uid,
            },
        },
        {
            signal,
        },
    )
    return response.data
}

export interface IChangeUserRequest {
    user: {
        username: string
    }
}

export async function switchAccount(
    { userId, username }: { userId: number; username: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<AuthenticationResponse> {
    const response = await axios.post(
        `/users/${userId}/changeAccount`,
        {
            user: {
                username,
            },
        },
        {
            signal,
        },
    )

    return response.data
}

export async function sendUserAccountsConfirmationEmail(
    { userId }: { userId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<GetUserAccountsResponse> {
    const response = await axios.post(
        `/users/${userId}/sendConfirmEmail`,
        {},
        {
            signal,
        },
    )
    return response.data
}

export async function confirmEmailAddress(
    { userId, otp }: ConfirmEmailParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<GetUserAccountsResponse> {
    const response = await axios.post(
        `/users/${userId}/confirmEmail?otp=${otp}`,
        {},
        {
            signal,
        },
    )
    return response.data
}

export async function downloadGdprData(
    { userId }: { userId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<Blob> {
    const response = await axios.get(`/users/${userId}/gdpr/export/user-data`, {
        headers: { Accept: "application/zip" },
        responseType: "arraybuffer",
        signal,
    })
    return new Blob([response.data], {
        type: response.headers["content-type"]?.toString() ?? "application/zip",
    })
}
